// S ::: 수강료 리스트 ::: S
export const pricingList = [
  {
    type: "단체반 수업 CLASS",
    class: [
      {
        mainTitle: "셔플",
        mainTitleDesc: "",
        course: [
          {
            subTitle: "4회 수업",
            desc: "",
            price: "16만원",
          },
          {
            subTitle: "1회 수업",
            desc: "",
            price: "4.5만원",
          },
        ],
      },
      {
        mainTitle: "시니어 셔플",
        mainTitleDesc: "",
        course: [
          {
            subTitle: "4회 수업",
            desc: "",
            price: "16만원",
          },
          {
            subTitle: "1회 수업",
            desc: "",
            price: "4.5만원",
          },
        ],
      },
      {
        mainTitle: "KPOP",
        mainTitleDesc: "",
        course: [
          {
            subTitle: "4회 수업",
            desc: "",
            price: "13만원",
          },
          {
            subTitle: "1회 수업",
            desc: "",
            price: "3.5만원",
          },
        ],
      },
      {
        mainTitle: "스트릿",
        mainTitleDesc: "(하우스, 힙합)",

        course: [
          {
            subTitle: "4회 수업",
            desc: "",
            price: "14만원",
          },
          {
            subTitle: "1회 수업",
            desc: "",
            price: "3.7만원",
          },
        ],
      },
      // {
      //   mainTitle: `기초 기본기 트레이닝 2개월 프로그램 (90분)`,
      //   course: [
      //     {
      //       subTitle: "8회 수업 (2개월)",
      //       desc: "",
      //       price: "40만원",
      //     },
      //   ],
      // },
    ],
  },
  {
    type: "개인 레슨 PRIVATE",
    class: [
      {
        mainTitle: "개인 레슨",
        mainTitleDesc: "",
        course: [
          {
            subTitle: "1회 수업 (60분)",
            desc: "",
            price: "10만원",
          },
          {
            subTitle: "10회 수업 (60분씩)",
            desc: "",
            price: "95만원 (회당 5000원 할인)",
          },
          {
            subTitle: "20회 수업 (60분씩)",
            desc: "",
            price: "180만원 (회당 1만원 할인)",
          },
        ],
      },
      {
        mainTitle: "그룹 레슨",
        mainTitleDesc: "",
        course: [
          {
            subTitle: "2:1 수업 (60분)",
            desc: "",
            price: "14만원",
          },
          {
            subTitle: "3:1 수업 (60분)",
            desc: "",
            price: "18만원",
          },
        ],
      },
    ],
  },
];
// E ::: 수강료 리스트 ::: E

// S ::: 프리패스 리스트 ::: S
export const freepassList = [
  {
    type: "수강 가능 CLASS",
    class: [
      {
        mainTitle: "셔플",
        mainTitleDesc: "",
        course: [
          {
            subTitle: "셔플 LEVEL.1",
            subTitleDesc: "",
          },
          {
            subTitle: "셔플 LEVEL.2",
            subTitleDesc: "",
          },
          {
            subTitle: "셔플 LEVEL.3",
            subTitleDesc: "(레벨3는 1개의 수업만 선택가능)",
          },
        ],
      },

      {
        mainTitle: "그 외 장르",
        mainTitleDesc: "",
        course: [
          { subTitle: "힙합 비기너", subTitleDesc: "" },
          { subTitle: "힙합 레벨업", subTitleDesc: "" },
          { subTitle: "기초 기본기 트레이닝", subTitleDesc: "" },
          { subTitle: "KPOP", subTitleDesc: "" },
          { subTitle: "레트로 케이팝", subTitleDesc: "" },
          { subTitle: "하우스 비기너", subTitleDesc: "" },
        ],
      },
    ],
  },
];
// E ::: 프리패스 리스트 ::: E
